import axios from "axios";
import _ from "lodash";
import { ENV } from "@/constants";
import { useAuthStore } from "@/store/auth";

const baseurl = ENV.API_BASE_URL;
const clientKey = ENV.CLIENT_KEY;

const baseApi = axios.create({
  baseURL: !_.isEmpty(baseurl) ? baseurl : "http://localhost:5400/api/v1",
  headers: {
    "x-dex-client-key": clientKey,
  },
});

// intercept if we get expired token go to logout
baseApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response?.data?.message);
    if (error.response?.status === 401 && error.response?.data?.message.includes('token')) {
      useAuthStore.getState().clearAuthData()
      // refresh page for automatic redirect
      window.location.href = '/sign-in';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const setBaseApiToken = (token: string | null) => {
  baseApi.defaults.headers.common["Authorization"] = token;
};

export const getBaseApi = () => {
  return baseApi;
};